import { Folder } from "../customers/Folder";
import { WorkflowMap } from "./WorkflowMap";

export class ProjectSummary {

    id!: number;
    name!: string;
    sellerName!: string;
    dateCreated!: string;
    storeName!: string;
    currentStep!: WorkflowMap;
    folder?: Folder;
}